// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"84":"15df94af","153":"a471a84d","240":"a5f57151","349":"425c94c1","608":"30d1b0e1","661":"f7e80e8f","794":"6b5749bb","804":"b7c25075","875":"a65ee67e","911":"189e179c","961":"090123b8","973":"831b35a1"}[chunkId] + ".chunk.js";
};